import { render, staticRenderFns } from "./approve-warnings-modal.vue?vue&type=template&id=1a45f02e&scoped=true"
import script from "./approve-warnings-modal.vue?vue&type=script&lang=js"
export * from "./approve-warnings-modal.vue?vue&type=script&lang=js"
import style0 from "./approve-warnings-modal.vue?vue&type=style&index=0&id=1a45f02e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a45f02e",
  null
  
)

export default component.exports